var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88383 4.1542C3.88383 1.86847 5.7523 0 8.03803 0C10.3238 0 12.1922 1.86847 12.1922 4.1542C12.1922 6.43993 10.3238 8.3084 8.03803 8.3084C5.7523 8.3084 3.88383 6.43993 3.88383 4.1542ZM14.7501 10.8662C14.9133 11.102 15.0584 11.356 15.1673 11.6281C15.2217 11.7369 15.2036 11.864 15.1129 11.9728C14.9678 12.2268 14.8045 12.4626 14.6231 12.6984C14.3691 13.0431 14.0789 13.3515 13.7887 13.6417C13.5347 13.8957 13.2444 14.1497 12.9542 14.3674C11.5211 15.4376 9.79772 16 8.01994 16C6.24217 16 4.5188 15.4377 3.08571 14.3674C2.79543 14.1315 2.50519 13.8957 2.25123 13.6417C1.94283 13.3515 1.67071 13.0431 1.41675 12.6984C1.25349 12.4808 1.0721 12.2268 0.926958 11.9728C0.872549 11.864 0.854424 11.737 0.908833 11.6281C1.01765 11.3742 1.16279 11.102 1.32606 10.8662C2.14237 9.63264 3.44849 8.81632 4.89974 8.61677C5.08112 8.58049 5.28067 8.6349 5.42581 8.74375C6.18772 9.30611 7.09474 9.59635 8.03807 9.59635C8.9814 9.59635 9.88841 9.30611 10.6503 8.74375C10.7955 8.6349 10.995 8.59865 11.1764 8.61677C12.6277 8.81632 13.9156 9.63264 14.7501 10.8662Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.392c99065d940abd571fd2cdb1803d37.svg";
export { ForwardRef as ReactComponent };